export default __webpack_public_path__ + "static/media/star-glyph-16px-blue.69985c67.svg";